import { Enum } from './TenantSubscriptionStatus';

/**
 * Unpaid status levels (TDD-5598). Separate dimension from the Chargebee
 * subscription status: a tenant can be active + blocked, non-renewing + blocked, etc.
 * Levels are fixed at 4 and implemented in code (not configurable at this stage).
 */
export const UNPAID_LEVEL = {
    NONE: 0,
    SOFT_REMINDER: 1,
    ATTENTION: 2,
    WARNING: 3,
    BLOCKED: 4,
} as const;

export type UnpaidLevel = Enum<typeof UNPAID_LEVEL>;

export const isUnpaidLevel = (value: number): value is UnpaidLevel => (Object.values(UNPAID_LEVEL) as number[]).includes(value);
